export class PplxError extends Error {
    code;
    details;
    constructor(code, { message, cause, details = {}, } = {}) {
        super(message ? `[${code}] ${message}` : `[${code}]`, { cause });
        this.code = code;
        this.code = code;
        this.details = details;
        this.name = 'PplxError';
        if ('captureStackTrace' in Error && typeof Error.captureStackTrace === 'function') {
            // Capture the stack trace for better debugging, if supported
            Error.captureStackTrace(this, PplxError);
        }
    }
}
//# sourceMappingURL=errors.js.map